import React from 'react';
import './MeetingsSection.scss';
import { NavLink } from 'react-router-dom';
import CustomBtn from '../../../../components/CustomBtn/CustomBtn';
import { isExternalLink, safeHtml } from '../../../../services/helpers';
import StrapiImageWithSkeleton from '../../../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';

const MeetingsSection = ({ strapiData }) => {
    
    return (
        <section className="meetings-section">
            <h2 className="meetings-section__title">{strapiData.Titre_section}</h2>
            <div className="meetings-section__grid">
                {
                    strapiData.Cartes_Rencontre.map((carte) => (
                        <div key={carte.id} className="meetings-section__card">
                            <NavLink
                                to="/cercles-de-mamans"
                                className={({ isActive }) =>
                                    isActive ? "link active" : "link"
                                }
                            >
                                <div className="meetings-section__image">
                                    <StrapiImageWithSkeleton
                                        picture={carte?.Photo}
                                        borderRadius='50%'
                                        loading="lazy"
                                        size="small"
                                    />
                                    <h3 className="meetings-section__card-title">
                                        <span className="card_text1" style={{color: carte.Titre1_Color}}>{carte.Titre1}</span>
                                        <span className="card_text2" style={{color: carte.Titre2_Color}}>{carte.Titre2}</span>
                                        <span className="card_text3" style={{color: carte.Titre3_Color}}>{carte.Titre3}</span>
                                    </h3>
                                </div>
                            </NavLink>
                            <div className="meetings-section__card-text" dangerouslySetInnerHTML={safeHtml(carte.Description)} />
                            <CustomBtn
                                type={isExternalLink(carte.Bouton.LienBouton) ? 'external' : 'internal'}
                                title={carte.Bouton.TexteBouton}
                                link={
                                    carte.Bouton.LienBouton === null ?
                                        ''
                                    :
                                        (isExternalLink(carte.Bouton.LienBouton) ?
                                            carte.Bouton.LienBouton
                                        :
                                            '/' + carte.Bouton.LienBouton)
                                }
                                bkg_color={'transparent'}
                                bkg_color_hover={'#EEE6DB'}
                                text_color={'#361215'}
                                text_color_hover={'#361215'}
                                border_color={'#361215'}
                                border_color_hover={'#361215'}
                                font_family={"Great Vibes"}
                                font_size={'30px'}
                                font_weight={'normal'}
                                border_radius={'3px'}
                                width={'240px'}
                                height={'55px'}
                                margin={'10px 0'}
                                letter_spacing={2}
                            />
                        </div>
                    ))
                }
            </div>
        </section>
    );
};

export default MeetingsSection;